/** Ross registered these on the general API version (`api-2022-12-23.php`). */
export const RELATIONSHIP_TAGS_API_VERSION = '2022-12-23';

export const relationshipTagsApiPaths = {
  categories: '/relationship-tag-categories',
  category: (id: string) => `/relationship-tag-categories/${id}`,
  tags: '/relationship-tags',
  tag: (id: string) => `/relationship-tags/${id}`
} as const;
